import React from 'react';

type Props = {
  content: string;
};

export default function BaseTextEditorContent(props: Props) {
  const { content } = props;

  return (
    <span
      className="ql-editor"
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    />
  );
}
